import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.748 4C12.748 3.58579 12.4123 3.25 11.998 3.25C11.5838 3.25 11.248 3.58579 11.248 4L11.248 11.2461H4C3.58579 11.2461 3.25 11.5819 3.25 11.9961C3.25 12.4103 3.58579 12.7461 4 12.7461H11.248L11.248 20C11.248 20.4142 11.5838 20.75 11.998 20.75C12.4123 20.75 12.748 20.4142 12.748 20V12.7461H20C20.4142 12.7461 20.75 12.4103 20.75 11.9961C20.75 11.5819 20.4142 11.2461 20 11.2461H12.748V4Z" }, null, -1)
  ])))
}
export default { render: render }